import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("修改")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditorComponent = _resolveComponent("EditorComponent")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_component_EditorComponent, {
      ref: "editorComponentRef",
      key: _ctx.protocolType,
      content: _ctx.detail,
      height: 700
    }, null, 8, ["content"])),
    _createVNode(_component_a_button, {
      type: "primary",
      style: {"margin-top":"15px"},
      loading: _ctx.loading,
      onClick: _ctx.onEdit
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["loading", "onClick"])
  ]))
}